export default {
    title: {
        USER_ALREADY_HAS_ACCESS: 'Acesso já existe',
        invalidInvite: 'Convite inválido',
    },
    text: {
        USER_ALREADY_HAS_ACCESS: 'O usuário já possui este acesso. Retorne para a tela de login.',
        invalidInvite: 'O convite utilizado foi invalidado. Solicite o envio de um novo convite.',
    },
    button: 'Ir para login'
}